<template>
  <div class="ac-card-content">
    <div class="invite-header-container">
      <div class="header-row-container">
        <button
          class="ac-close-button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="reset-header">
          Reset Password
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="invite-input-container">
        <SACRadio
          field="createPassword"
          :value="false"
          :checked="createPassword === false"
          :change="change"
          label="Ask user to change password when they sign in"
        />
      </div>
      <div class="invite-input-container">
        <SACRadio
          field="createPassword"
          :value="true"
          :checked="createPassword === true"
          :change="change"
          label="Create Password"
        />
      </div>
      <div
        v-if="createPassword"
        class="invite-input-container"
      >
        <input
          id="password"
          v-model="techPassword"
          :type="inputType"
          class="p-input"
          autocomplete="false"
        >
        <div class="pwd-visibility">
          <img
            v-if="showPassword"
            class="eyeball-img"
            src="@shared/assets/img/general/show-password.png"
            alt="show-password"
            @click="toggleVisibility()"
          >
          <img
            v-else
            class="eyeball-img"
            src="@shared/assets/img/general/hide-password.png"
            alt="hide-password"
            @click="toggleVisibility()"
          >
        </div>
        <div v-if="errObj.password">
          <span class="password-error">
            {{ errObj.password[0] }}
          </span>
        </div>
      </div>
    </div>
    <div class="invite-footer-container">
      <button
        class="invite-form-cancel-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="resetPassword"
      >
        {{ createPassword ? "Update Password" : "Send Email" }}
      </button>
    </div>
  </div>
</template>
<script>
import technicianMixin from '@shared/mixins/technicianMixin';
import SACRadio from '@shared/components/sac/SACRadio.vue';
import errorCatch from '@shared/lib/errorCatch/passwordValidation';

export default {
  name: 'ResetTechnicianPasswordConfirmation',
  components: {
    SACRadio,
  },
  mixins: [technicianMixin],
  data() {
    return {
      errObj: {},
      createPassword: false,
      showPassword: false,
      techPassword: '',
      inputType: 'password',
    };
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    resetPassword() {
      let tech;
      const errObj = {};
      const passwordErrs = [];
      if (this.createPassword && !this.techPassword) {
        passwordErrs.push('Please enter the technician\'s new password');
      }
      if (this.createPassword && this.techPassword) {
        const passwordStrength = errorCatch(this.techPassword);
        if (passwordStrength) {
          passwordStrength.forEach((ps) => {
            if (ps === 'min'
              || ps === 'uppercase'
              || ps === 'digits'
              || ps === 'spaces'
            ) {
              passwordErrs.push('Please include 8 characters, a capital letter, and a number.');
            }
          });
        }
      }
      if (passwordErrs.length > 0) {
        errObj.password = passwordErrs;
      }
      this.errObj = errObj;
      if (Object.keys(this.errObj).length === 0) {
        if (!this.createPassword) {
          tech = {
            ...this.selectedTech,
            createPassword: !this.createPassword,
          };
        } else {
          tech = {
            ...this.selectedTech,
            password: this.techPassword,
          };
        }
        const adminCreated = this.createPassword;
        this.$store.dispatch('resetTechPassword', {
          tech,
          adminCreated,
        });
        this.toggleActionModal(false);
      }
    },
    toggleVisibility() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.inputType = 'text';
      } else {
        this.inputType = 'password';
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.invite-header-container {
  padding-top: 29px;
  padding-right: 24px;
  padding-left: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-row-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.reset-header {
  font-size: 1.25rem;
  font-weight: 600;
  margin-left: 5px;
}

.invite-footer-container {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid $NBLUE10;

  button:not(:last-child) {
    margin-right: 12px;
  }

  .ac-form-button {
    padding: 0 16px;
    height: 40px;
    border-radius: 6px;
    background-color: $NBLUE100;
    color: $WHITE;
    font-weight: 600;

    &:hover {
      background-color: $NBLUE90;
    }

    &:disabled {
      background-color: $N50
    }

    ;

    &:not(:last-child) {
      margin-left: 11px;
      background-color: $NBLUE10;
      color: $N50;

      &:hover {
        background-color: $NBLUE20;
      }
    }
  }

  .invite-form-cancel-button {
    padding: 0 16px;
    height: 40px;
    border-radius: 6px;
    background-color: $N50;
    color: $WHITE;
    font-weight: 600;

    &:hover {
      background-color: $TOMATO200;
    }
  }
}

.invite-input-container {
  position: relative;
  padding-left: 15px;
  margin-bottom: 10px;
}

.p-input {
  border: 1px solid $N10;
  width: 100%;
  height: 45px;
  border-radius: 5px;
  padding: 0 10px;

  &:focus {
    background-color: $NBLUE10;
  }

  @media (max-width: 420px) {
    height: 35px;
  }
}

.pwd-visibility {
  position: absolute;
  right: 10px;
  top: 15px;

  @media (max-width: 420px) {
    top: 35px;
  }

  .eyeball-img {
    height: 20px;
    width: 20px;
    cursor: pointer;

    @media (max-width: 420px) {
      height: 15px;
      width: 15px;
    }
  }
}

.password-error {
  color: $TOMATO100;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 5px;

  @media (max-width: 420px) {
    font-size: 0.75rem;
  }
}
</style>
